import { ImageUrlsResized } from "../../models/images.model";

export default class SwiperBackgroundLooper {
  private prevBackgroundIndex: number;
  private backgrounds: ImageUrlsResized[];

  constructor(backgrounds: ImageUrlsResized[]) {
    this.backgrounds = backgrounds;
    this.prevBackgroundIndex = backgrounds.length - 1;
  }

  getBackground() {
    if (this.backgrounds.length) {
      const isLast = this.prevBackgroundIndex === this.backgrounds.length - 1;
      if (isLast) {
        this.prevBackgroundIndex = 0;
      } else {
        this.prevBackgroundIndex++;
      }

      return this.backgrounds[this.prevBackgroundIndex];
    } else {
      return null;
    }
  }
}
